/* ================= Baby Harmonie v2 — animations supplémentaires + bundle ================= */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  function ready(fn) { if (document.readyState === 'complete') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  function money(cents) {
    try {
      if (window.theme && theme.Currency && theme.Currency.formatMoney) return theme.Currency.formatMoney(cents, theme.settings.moneyFormat);
    } catch (e) {}
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  ready(function () {
    /* ---------- Barre de progression + en-tête + retour en haut ---------- */
    var prog = document.createElement('div');
    prog.className = 'bh-progress';
    prog.innerHTML = '<span></span>';
    document.body.appendChild(prog);
    var bar = prog.firstChild;

    var top = document.createElement('button');
    top.type = 'button';
    top.className = 'bh-top';
    top.setAttribute('aria-label', 'Revenir en haut de la page');
    top.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M12 19V5M6 11l6-6 6 6"/></svg>';
    document.body.appendChild(top);
    top.addEventListener('click', function () { window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }); });

    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var h = document.documentElement.scrollHeight - window.innerHeight;
        var y = window.pageYOffset;
        bar.style.transform = 'scaleX(' + (h > 0 ? Math.min(y / h, 1) : 0) + ')';
        root.classList.toggle('bh-scrolled', y > 40);
        top.classList.toggle('is-visible', y > 700);
        ticking = false;
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();

    /* ---------- Cascade sur les grilles produits ---------- */
    if (root.classList.contains('bh-anim')) {
      var cards = document.querySelectorAll('.grid-product, .collection-item, .testimonials-slide');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('bh-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -6% 0px', threshold: 0.05 });
      cards.forEach(function (c) {
        var idx = Array.prototype.indexOf.call(c.parentNode.children, c);
        c.classList.add('bh-cascade');
        c.style.setProperty('--bh-delay', ((idx % 4) * 0.1).toFixed(2) + 's');
        io.observe(c);
      });
      setTimeout(function () { cards.forEach(function (c) { c.classList.add('bh-in'); }); }, 6000);
    }

    /* ---------- Fiche produit : blocs en cascade + prix animé ---------- */
    document.querySelectorAll('.template-product [data-product-blocks] > .product-block').forEach(function (b, i) {
      b.style.setProperty('--bh-delay', (0.08 + i * 0.06).toFixed(2) + 's');
    });
    var priceEl = document.querySelector('.template-product [data-product-price]');
    if (priceEl && 'MutationObserver' in window) {
      new MutationObserver(function () {
        priceEl.classList.remove('bh-price-flash'); void priceEl.offsetWidth; priceEl.classList.add('bh-price-flash');
      }).observe(priceEl, { childList: true, characterData: true, subtree: true });
    }

    /* ---------- Icône panier qui rebondit ---------- */
    function bumpCart() {
      document.querySelectorAll('.js-drawer-open-cart, .cart-link').forEach(function (el) {
        el.classList.remove('bh-bump'); void el.offsetWidth; el.classList.add('bh-bump');
      });
    }
    document.addEventListener('ajaxProduct:added', bumpCart);

    /* ---------- Bundle « Complétez votre pack » ---------- */
    document.querySelectorAll('[data-bh-bundle]').forEach(function (box) {
      var tier2 = parseFloat(box.dataset.tier2) || 10;
      var tier3 = parseFloat(box.dataset.tier3) || 15;
      var items = Array.prototype.slice.call(box.querySelectorAll('[data-bh-item]'));
      var totalEl = box.querySelector('[data-bh-total]');
      var cmpEl = box.querySelector('[data-bh-compare]');
      var saveEl = box.querySelector('[data-bh-save]');
      var btn = box.querySelector('[data-bh-add]');
      var label = box.querySelector('[data-bh-label]');
      var errEl = box.querySelector('[data-bh-error]');
      var lastTotal = null;

      function itemPrice(li) {
        var sel = li.querySelector('select[data-bh-variant]');
        if (sel) {
          var opt = sel.options[sel.selectedIndex];
          if (opt && opt.dataset.price) li.dataset.price = opt.dataset.price;
        }
        return parseInt(li.dataset.price, 10) || 0;
      }

      function update() {
        var sum = 0, count = 0;
        items.forEach(function (li) {
          var cb = li.querySelector('input[type="checkbox"]');
          var on = cb ? cb.checked : true;
          li.classList.toggle('is-checked', on);
          var p = itemPrice(li);
          li.querySelector('[data-bh-price]').textContent = money(p);
          if (on) { sum += p; count++; }
        });
        var pct = count >= 3 ? tier3 : (count === 2 ? tier2 : 0);
        var total = Math.round(sum * (1 - pct / 100));
        totalEl.textContent = money(total);
        if (pct > 0) {
          cmpEl.hidden = false; cmpEl.textContent = money(sum);
          saveEl.hidden = false; saveEl.textContent = 'Vous économisez ' + money(sum - total) + ' (-' + pct + ' %)';
        } else {
          cmpEl.hidden = true; saveEl.hidden = true;
        }
        label.textContent = count > 1 ? 'Ajouter le pack (' + count + ' articles) au panier' : 'Ajouter au panier';
        if (lastTotal !== null && lastTotal !== total) {
          totalEl.classList.remove('bh-tick'); void totalEl.offsetWidth; totalEl.classList.add('bh-tick');
        }
        lastTotal = total;
      }

      box.addEventListener('change', update);

      /* Suit la variante choisie dans le formulaire principal */
      var mainForm = document.getElementById(box.dataset.mainForm);
      var mainItem = box.querySelector('.bh-bdl__item.is-main');
      function syncMain() {
        if (!mainForm || !mainItem) return;
        var idInput = mainForm.querySelector('[name="id"]');
        if (!idInput) return;
        var vid = idInput.value;
        mainItem.querySelector('[data-bh-variant]').value = vid;
        var json = mainForm.querySelector('[data-variant-json]');
        var data = null;
        try { if (json) data = JSON.parse(json.value || json.textContent); } catch (e) {}
        if (data && data.length) {
          data.forEach(function (v) {
            if (String(v.id) === String(vid)) {
              mainItem.dataset.price = v.price;
              var vEl = mainItem.querySelector('[data-bh-main-variant]');
              if (vEl && v.title !== 'Default Title') vEl.textContent = v.title;
            }
          });
        }
        update();
      }
      if (mainForm) mainForm.addEventListener('change', function () { setTimeout(syncMain, 120); });

      btn.addEventListener('click', function () {
        errEl.hidden = true;
        var payload = [];
        items.forEach(function (li) {
          var cb = li.querySelector('input[type="checkbox"]');
          if (cb && !cb.checked) return;
          var v = li.querySelector('[data-bh-variant]');
          if (v && v.value) payload.push({ id: parseInt(v.value, 10), quantity: 1 });
        });
        if (!payload.length) return;
        btn.classList.add('is-loading');
        label.textContent = 'Ajout en cours…';
        fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: payload })
        }).then(function (r) {
          return r.json().then(function (d) { if (!r.ok) throw d; return d; });
        }).then(function (d) {
          btn.classList.remove('is-loading');
          btn.classList.add('is-done');
          label.textContent = 'Pack ajouté !';
          var drawer = document.getElementById('CartDrawer');
          if (drawer && window.theme && theme.settings && theme.settings.cartType === 'drawer') {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: d.items ? d.items[0] : d } }));
          } else {
            bumpCart();
            setTimeout(function () { window.location.href = (window.theme && theme.routes && theme.routes.cartPage) || '/cart'; }, 600);
          }
          setTimeout(function () { btn.classList.remove('is-done'); update(); }, 2500);
        }).catch(function (e) {
          btn.classList.remove('is-loading');
          errEl.hidden = false;
          errEl.textContent = (e && (e.description || e.message)) || 'Impossible d’ajouter le pack. Réessayez.';
          update();
        });
      });

      syncMain();
      update();
    });
  });
})();
